import Image from "next/image"

import { AssetProps } from "./types"

interface VisaLogoProps extends AssetProps {
  color: "white" | "black"
}

export function VisaLogo(props: VisaLogoProps) {
  const whiteLogoSrc = "/visa-white.svg"
  const blackLogoSrc = "/visa-black.svg"

  return (
    <Image
      src={props.color === "white" ? whiteLogoSrc : blackLogoSrc}
      alt="Visa Logo"
      {...props}
    />
  )
}
